import { container } from "tsyringe";
import RoleApi from "api/clapaction/projects/[id]/config/team/[projectTeamId]/RoleApi";
import ProjectTeamRoleContributorsRequestResource from "common/resources/Project/Config/Team/Role/ProjectTeamRoleContributorsRequestResource";
import ProjectTeamRoleContributorsResponseResource from "common/resources/Project/Config/Team/Role/ProjectTeamRoleContributorsResponseResource";
import toValidationError from "utils/toValidationError";

export default class RoleService {
	private api: RoleApi = container.resolve(RoleApi);

	/**
	 * @description Get all by project team id
	 */
	public async getAllByProjectTeamId(projectId: string, projectTeamId: string): Promise<ProjectTeamRoleContributorsResponseResource[]> {
		return this.api.getAllByProjectTeamId(projectId, projectTeamId).catch(toValidationError);
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, projectTeamId: string, roleId: string): Promise<ProjectTeamRoleContributorsResponseResource> {
		return this.api.getById(projectId, projectTeamId, roleId).catch(toValidationError);
	}

	/**
	 * @description Create a new role with contributors for a project team
	 */
	public async create(projectId: string, projectTeamId: string, request: ProjectTeamRoleContributorsRequestResource): Promise<ProjectTeamRoleContributorsResponseResource> {
		return this.api.create(projectId, projectTeamId, request).catch(toValidationError);
	}

	/**
	 * @description Update a role with contributors for a project team
	 */
	public async update(
		projectId: string,
		projectTeamId: string,
		roleId: string,
		request: ProjectTeamRoleContributorsRequestResource,
	): Promise<ProjectTeamRoleContributorsResponseResource> {
		return this.api.update(projectId, projectTeamId, roleId, request).catch(toValidationError);
	}

	/**
	 * @description Add a contributor to a role for a project team
	 */
	public async addContributor(projectId: string, projectTeamId: string, roleId: string, contributorId: string): Promise<void> {
		return this.api.addContributor(projectId, projectTeamId, roleId, contributorId).catch(toValidationError);
	}

	/**
	 * @description Remove a contributor from a role for a project team
	 */
	public async removeContributor(projectId: string, projectTeamId: string, roleId: string, contributorId: string): Promise<void> {
		return this.api.removeContributor(projectId, projectTeamId, roleId, contributorId).catch(toValidationError);
	}

	/**
	 * @description Delete a role for a project team
	 */
	public async delete(projectId: string, projectTeamId: string, roleId: string): Promise<void> {
		return this.api.delete(projectId, projectTeamId, roleId).catch(toValidationError);
	}
}
